export default "__VITE_PUBLIC_ASSET__652752da__"